export default __webpack_public_path__ + "static/media/COPD-Stable-1.310ce421.jpg";